import React, { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import Accueil from "./Accueil/Accueil";
import { IReduxState } from "./store";
import { setServerUrl } from "./store/appSlice";
import { ADMIN_SERVER_BASE_URL } from "./util/apiClient";
import { isDev } from "./util/functions";
import Login from "./Login";

function App() {
  //redux
  const dispatch = useDispatch();
  const { serverUrl, userLoggedIn } = useSelector((state: IReduxState) => state.application);

  //hooks
  const [cookies, setCookie] = useCookies(["serverUrl"]);


  /**
   * au demarrage de l'appli, on récupère l'adresse
   * du serveur, via les cookies si on est en mode prod.
   * En mode dev, l'adresse est en dure dans le store
   * */
  useEffect(() => {
    if (!isDev()) dispatch(setServerUrl(cookies.serverUrl));
  }, []);

  return (
    <div style={{ overflow: "hidden", height: "100vh" }}>
      {userLoggedIn
        ? <Accueil />
        : <Login />
      }
    </div>
  );
}

export default App;
